export default {
    props: ['leadsIdEdit'],
    data: () => ({
        showDialog: false,
        status: 'Offered',
        ddTestSelectedOption: "scheduled",
        assignTherapist: "Assign a Therapist",
        ddTestSelectedOption2: "",
        reason: '',
        scheduledChecked: false,
        unclaimed: false,
        scheduled: false,
        options: [
            {
                "value": "Scheduled",
                "text": "Scheduled"
            },
            {
                "value": "Offered",
                "text": "Offered"
            },
            {
                "value": "PatientCancelled",
                "text": "Patient Cancelled"
            },
            {
                "value": "Claimed",
                "text": "Claimed"
            },
            {
                "value": "Unclaimed",
                "text": "Unclaimed"
            },
            {
                "value": "Ready",
                "text": "Ready"
            },
        ]
    }),
    watch: {
        async leadsIdEdit () {
            try {
                const res = await this.$newpetehealthapi.get(`/leads/${this.leadsIdEdit}/offer_details`);
                if (res && res.data) {
                    this.offerDetail = res.data.leads_offer_details
                }
            } catch (e) {
                console.log('data', this.posted_offers)
            }
        }
    },
    methods: {
        changeItem: async function () {},
        submitOfferDetail() {
            this.$newpetehealthapi.post(`/leads/${this.leadsIdEdit}/update_offer`,
                {
                    offer: {
                        status: this.ddTestSelectedOption,
                        refuse_reason: this.reason
                    },
                }
            )
                .then(request => {
                    window.location.reload()
                    this.loginSuccessful(request)
                })
                .catch(() => this.loginFailed())
        }
    },
};
